import React from 'react';
import Radium from 'radium';
import {Device, darkGray} from './shared.js';

import Logo from './logo.js';
import Portrait from './portrait.js';
import HerosectionImage from '../assets/herosection.jpg';

export default Radium(() => {
  let height = 450;
  if (Device.isTablet()) {
    height = 400;
  }
  if (Device.isMobile()) {
    height = 235;
  }
  const style = {
    herosection: {
      backgroundImage: `url(${ HerosectionImage })`,
      backgroundPosition: 'center 35%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      borderBottomColor: darkGray,
      borderBottomStyle: 'solid',
      borderBottomWidth: 15,
      height: height,
      zIndex: 2,
      position: 'relative',
      width: '100%',
    },

    header: {
      boxSizing: 'border-box',
      color: '#FFFFFF',
      fontSize: Device.isMobile() ? 10 : 18,
      fontWeight: Device.isMobile() ? 500 : 300,
      left: '50%',
      letterSpacing: Device.isMobile() ? .5 : 1.5,
      margin: 0,
      paddingTop: 5,
      position: 'absolute',
      textAlign: 'center',
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap',
    },

    span: {
      backgroundColor: 'white',
      height: 1,
      position: 'absolute',
      top: 'calc(50% + 1px)',
      width: '50vw',
      right: {
        right: 'calc(100% + 15px)',
      },
      left: {
        left: 'calc(100% + 15px)',
      },
    }
  }
 
  return (
    // id is needed in navigation
    <div id="herosection" style={ style.herosection }>
      <span style={ style.header }>
        <span style={ [style.span, style.span.left] } />
        Familienrecht ・ Arbeitsrecht ・ Verkehrsrecht ・ Zivilrecht
        <span style={ [style.span, style.span.right] } />
      </span>
      <Logo />
      <Portrait />
    </div>
  );
})


// WEBPACK FOOTER //
// ./src/modules/herosection.js